import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@material-ui/core/Tooltip';
import { approxFormatNumber } from 'cityads-v3/utils/textUtils';

import classes from './ShareButton.scss';

export default class ShareButton extends PureComponent {
  static propTypes = {
    icon   : PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    count  : PropTypes.number,
    tooltip: PropTypes.node,
    url    : PropTypes.string,
    onClick: PropTypes.func,
  }

  state = {
    showTooltip: false
  }

  render() {
    const { icon, count, tooltip, onClick } = this.props;

    return (
      <Tooltip
        title={tooltip}
        placement="top-start"
      >
        <button
          className    = {classes.button}
          onClick      = {onClick}
        >
          {typeof icon === 'string' ?
            (
              <img className={classes.icon} src={icon} alt={tooltip} />
            ) :
            icon
          }
          {typeof count === 'number' ?
            (
              <span className={classes.count}>{approxFormatNumber(count)}</span>
            ) :
            null
          }
        </button>
      </Tooltip>
    );
  }
}
